var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.8833 5H11.6666C12.1087 5 12.5326 5.17559 12.8451 5.48816C13.1577 5.80072 13.3333 6.22464 13.3333 6.66667V8.75L17.7066 6.19833C17.77 6.16138 17.8419 6.14179 17.9152 6.14155C17.9885 6.1413 18.0606 6.1604 18.1242 6.19692C18.1878 6.23344 18.2406 6.28608 18.2773 6.34954C18.314 6.413 18.3333 6.48502 18.3333 6.55833V13.3883",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 13.3333C13.3334 13.7754 13.1578 14.1993 12.8453 14.5118C12.5327 14.8244 12.1088 15 11.6667 15H3.33341C2.89139 15 2.46746 14.8244 2.1549 14.5118C1.84234 14.1993 1.66675 13.7754 1.66675 13.3333V6.66667C1.66675 6.22464 1.84234 5.80072 2.1549 5.48816C2.46746 5.17559 2.89139 5 3.33341 5H5.00008",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 1.66699L18.3334 18.3337",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_3059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOff);
export default __webpack_public_path__ + "static/media/video_off.4bac25d4aaed4d9beeec73f1b4274442.svg";
export { ForwardRef as ReactComponent };